// pages/FormViewerPage/components/VariantOptions/variantDetails.ts — Variant combo lookup for a test selection
import type { VariantCombination } from './types';

export function getVariantDetails(
    optionName: string,
    attributeValue: string,
    selectedOptions: Record<string, string>,
    resolvedVariantCombinations: VariantCombination[] | null,
    compositeFallback: { buildCombinedValue: (sel: Record<string, string>) => string | null } | null
): VariantCombination | null {
    if (!resolvedVariantCombinations || resolvedVariantCombinations.length === 0) return null;
    const testSelection = { ...selectedOptions, [optionName]: attributeValue };
    if (compositeFallback) {
        const combined = compositeFallback.buildCombinedValue(testSelection);
        if (!combined) return null;
        return resolvedVariantCombinations.find(combo => {
            const keys = Object.keys(combo.attributes || {});
            const key = keys[0];
            return key && combo.attributes[key] === combined;
        }) || null;
    }
    return resolvedVariantCombinations.find(combo =>
        Object.entries(testSelection).every(([key, val]) =>
            combo.attributes[key] === val
        )
    ) || null;
}
